// Load polyfills
import 'core-js/fn/promise'
import 'core-js/fn/object/assign'
import 'url-polyfill'

// Make sure to register before importing any components
import './class-component-hooks'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import VueHeadful from 'vue-headful'

import App from './App'
import store from '@/store'
import router from '@/router'

import setupFontAwesome from '@/helpers/font-awesome'
import setupInterceptors from '@/helpers/interceptors'
import setupAnalytics, {logEvent} from '@/helpers/google-analytics'

setupFontAwesome()
setupInterceptors()
setupAnalytics()

Vue.config.productionTip = false

// Define instance properties:
// https://vuejs.org/v2/cookbook/adding-instance-properties.html
Vue.prototype.$APP_PUBLIC_BASE_URL = 'https://tools.nycenet.edu'
Vue.prototype.$STATIC_PATH = process.env.STATIC_PATH
Vue.prototype.$TRANSLATE_ELEMENT = document.getElementById('google_translate_element')

Vue.component('VueHeadful', VueHeadful)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

window.onbeforeprint = function () {
  logEvent(Vue, 'global', 'printRequested', 'print')
}



// WEBPACK FOOTER //
// ./src/main.js